import React from "react";
import { validatorField, validateTextOnlyAlphanumeric } from "../../Utils/validators";
import ErrorCustom from "../errorCustom";

const Quiz = ({title, register, data, errors, orders, setOrders}: any) => {
  const handleChange = (e: any, pos: any, value: any) => {
    if (e.target.value != value) {
      setOrders([
        ...orders,
        `${pos}.`
      ]);
    }
    else {
      setOrders(orders.filter((elem: any) => elem !== `${pos}.`));
    }
  }

  const contains = (array: any, string: any) => {
    for (let i = 0; i < array.length; i += 1) {
      if (string.startsWith(array[i])) {
        return true;
      }
    }
    return false;
  }

  return (
    <>
    <div className="title">{title}</div>
    {data.map((item: any, index: number) => 
      <>
      {!contains(orders, item.entityData) &&
      <div 
        className={"question " + (item.metadata && item.metadata.classContainer ? item.metadata.classContainer : '')} 
        key={index}
      >
        {item.title &&
          <div className={"question__title " + (item.metadata && item.metadata.classTitle ? item.metadata.classTitle : 'sm')}>
            {item.metadata && typeof item.metadata.displayNumber === 'undefined' && `${item.entityData}. `}
            {item.title}
          </div>
        }
        {item.questionType === 'checkbox' &&
          <div className="question__control__checkbox">
            {item.metadata.options.map((option: any, idx: any) => 
              <div className="question__control__checkbox__item" key={idx}>
                <label>
                  <input 
                    id={item.sk}
                    name={item.sk}
                    className="filled-in"
                    type="checkbox"
                    value={option.id}
                    ref={register({ validate: validatorField })}
                  />
                  <span>{option.value}</span>
                </label>
              </div>
            )}
            <ErrorCustom errors={errors} name={item.sk} />
          </div>
        }
        {item.questionType === 'textarea' &&
          <div className="question__control__textarea input-field">
            <textarea
              id={item.sk}
              name={item.sk}
              ref={register({ validate: validateTextOnlyAlphanumeric })}
              className="materialize-textarea"
              maxLength={item.metadata && item.metadata.maxLength ? item.metadata.maxLength : 250}
            ></textarea>
            <label htmlFor={item.sk}>{item.metadata && item.metadata.placeholder}</label>
            <ErrorCustom errors={errors} name={item.sk} />
          </div>
        }
        {item.questionType === 'input' &&
          <div className="question__control input-field">
            <input
              id={item.sk}
              name={item.sk}
              ref={register({ validate: validateTextOnlyAlphanumeric })}
              type="text"
              maxLength={item.metadata && item.metadata.maxLength ? item.metadata.maxLength : 100}
            />
            <label htmlFor={item.sk}>{item.metadata && item.metadata.placeholder}</label>
            <ErrorCustom errors={errors} name={item.sk} />
          </div>
        }
        {item.questionType === 'select' &&
          <div className="question__control">
            <label htmlFor={item.sk} className="active">{item.metadata && item.metadata.placeholder}</label>
            <select
              id={item.sk}
              name={item.sk}
              ref={register({ validate: validatorField })}
            >
              {item.metadata.options.map((option: any, idx: number) => 
                <option value={option} key={idx}>{option}</option>
              )}
            </select>
            <ErrorCustom errors={errors} name={item.sk} />
          </div>
        }
        {item.questionType === 'boolean' &&
          <>
            <div className="question__control__radioButton">
              <div className="question__control__radioButton__item">
                <label>
                  <input 
                    name={item.sk} 
                    type="radio"
                    ref={register({ validate: validatorField })}
                    value="1"
                    onChange={(e) => handleChange(e, item.entityData, item.metadata.continueWhen)}

                  />
                  <span>SI</span>
                </label>
              </div>
              <div className="question__control__radioButton__item">
                <label>
                  <input 
                    name={item.sk} 
                    type="radio"
                    ref={register({ validate: validatorField })}
                    value="0"
                    onChange={(e) => handleChange(e, item.entityData, item.metadata.continueWhen)}
                  />
                  <span>NO</span>
                </label>
              </div>
            </div>
            <ErrorCustom errors={errors} name={item.sk} />
            <div className="question__control__separator"></div>
          </>
        }
      </div>
      }
      </>
    )}
    </>
  );
};

export default Quiz;